/** The pages a navigation can end on that are not the application: no account, no page, no session. */
export const account = {
  titel: "Je account",
  uitleg:
    "Op deze pagina zie je welke gegevens JBNL van je heeft. Je kunt hier ook een wachtwoord instellen.",
  /** On the overzicht, beside the two halves of the site - shorter, because it is a card. */
  kaart: "Bekijk je accountgegevens. Je kunt ook een wachtwoord instellen.",
  wieUitleg:
    "Hieronder staan de gegevens die JBNL van je heeft. Klopt er iets niet? Pas je gegevens dan zelf aan in het JBNL Portaal.",
  adres: "E-mailadres",
  korpsen: "Korpsen",

  wachtwoord: {
    titel: "Wachtwoord",
    /** A password is a setting now, so its absence is an ordinary state and reads like one. */
    geen: "Je hebt geen wachtwoord ingesteld. Je kunt inloggen met een inloglink of met het account van je veiligheidsregio.",
    heeft:
      "Je logt in met je e-mailadres, je wachtwoord en een code uit je authenticator-app.",
    none: "Wil je liever met een wachtwoord inloggen? Stel dan hier een wachtwoord en een authenticator-app in.",
    set: "Wachtwoord instellen",
    together:
      "Bij een wachtwoord hoort altijd een authenticator-app. Je stelt ze hier samen in.",
    new: "Nieuw wachtwoord", // skipcq: SCT-A000 - a field label, not a credential
    repeat: "Herhaal het wachtwoord",
    current: "Huidig wachtwoord", // skipcq: SCT-A000 - a field label, not a credential
    policy: "Minimaal 12 tekens. Een langer wachtwoord is veiliger.",
    scan: "Scan de code met je authenticator-app",
    qrAlt: "QR-code voor je authenticator-app",
    manual: "Lukt scannen niet? Voer deze sleutel handmatig in: {{key}}",
    code: "Code uit de app",
    submit: "Wachtwoord instellen en app koppelen",
    change: "Wachtwoord wijzigen",
    changed: "Je wachtwoord is gewijzigd.",
    mismatch: "De twee wachtwoorden komen niet overeen.",
    remove: "Wachtwoord verwijderen",
    removeUitleg:
      "Verwijder je je wachtwoord? Dan log je weer in met een inloglink of met het account van je veiligheidsregio. We verwijderen dan ook de koppeling met je authenticator-app. Bevestig met een code uit je authenticator-app of met een herstelcode.",
    removeCode: "Code uit de app of herstelcode",

    done: {
      title: "Je wachtwoord is ingesteld.",
      codes:
        "Bewaar deze herstelcodes ergens veilig. Je ziet ze maar één keer. Ben je je authenticator-app en deze codes allebei kwijt? Dan kun je alleen nog met een inloglink inloggen.",
      confirm: "Ik heb ze bewaard",
    },

    errors: {
      "verkeerde-code": "De code klopt niet. Probeer het opnieuw.",
      geblokkeerd:
        "Je account is geblokkeerd, omdat je het te vaak hebt geprobeerd. Neem contact op met ICT via {{mailbox}}.",
      datalek:
        "Dit wachtwoord staat in een bekend datalek van een andere website. Kies een ander wachtwoord.",
      "al-gezet": "Dit account heeft al een wachtwoord.",
      geweigerd:
        "We accepteren dit wachtwoord niet. Kies een langer wachtwoord.",
      gezet: "",
      verwijderd: "",
    },
  },

  errors: {
    titel: "We kunnen je account niet ophalen",
    load: "We konden je account niet ophalen ({{status}}). Laad de pagina opnieuw.",
    tweedeFactor:
      "We konden de authenticator-app niet koppelen ({{status}}). Probeer het opnieuw.",
    wachtwoord:
      "We konden het wachtwoord niet opslaan ({{status}}). Probeer het opnieuw.",
  },

  unknown: {
    title: "Geen account gevonden",
    description:
      "Het inloggen is gelukt, maar we herkennen dit account nog niet.",
    /**
     * The Veiligheidsregio account comes first: it is the only lever that shortens the
     * beheerder's queue without moving any risk. See docs/adr/0018-identity-linking.md.
     */
    veiligheidsregio:
      "Waarschijnlijk heb je ingelogd met een ander e-mailadres dan het adres dat JBNL van je heeft. <strong>Probeer het eerst met het account van je veiligheidsregio</strong>. Dat adres staat meestal in het JBNL Portaal.",
    mailBefore: "Lukt dat niet? Mail dan ",
    mailAfter:
      " met je naam en je korps. Wij koppelen dan je account. Daarna kun je opnieuw inloggen.",
    portaal:
      "Sta je nog niet in het JBNL Portaal? Vraag je korps om je daar in te voeren. Daarna nemen wij je gegevens automatisch over.",
  },

  signInFailed: {
    title: "Inloggen is niet gelukt",
    description:
      "Het inloggen is halverwege gestopt. Een oud tabblad of de terugknop is meestal de oorzaak.",
    retry: "Opnieuw proberen",
  },

  notFound: {
    title: "Pagina niet gevonden",
    description: "Deze pagina bestaat niet.",
  },
} as const;
